// extracted by mini-css-extract-plugin
export default {"PomodoroDisplay":"PomodoroDisplay_PomodoroDisplay__6ktcp","PomodoroDisplay__sub":"PomodoroDisplay_PomodoroDisplay__sub__AmH0n"};